import React, { useEffect, useState } from 'react'
import { getDevelopmentalRubrics } from '../../../../../services/developmental-rubrics/developmental-rubrics.service'
import { useParams } from 'react-router-dom'
import SectionCollapse from '../../../../section/SectionCollapse'
import Loading from '../../../../Loading/Loading'
import { handlerErrorV2 } from '../../../../../utils/errors'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import CardUnitOfLearning from '../CardUnitOfLearning/CardUnitOfLearning'
import useDate from '../../../../../hooks/app/useDate'

const FormUnitOfLearning = ({ form, onChangeAlert }) => {
  const { curriculumId } = useParams()
  const [items, setItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const { determinateStatus } = useDate()

  useEffect(() => {
    const fetchData = async () => {
      if (!curriculumId) return
      setIsLoading(true)
      setError(null)
      try {
        const filter = {
          subjectId: form?.subjectId,
          yearlevel: form?.yearLevel,
          isActived: 'yes'
        }
        const response = await getDevelopmentalRubrics(curriculumId, filter)
        if (!response?.data && response?.error) {
          setError(response.error.message || 'An error ocurred')
        } else {
          const data = response?.data
            ?.map((item) => ({
              ...item,
              status:
                item.startDate && item.endDate ? determinateStatus(item.startDate, item.endDate) : 'inactive'
            }))
            .filter((item) => item.status === 'active')
          setItems(data || null)
          onChangeAlert('unitOfLearnings', data || null)
        }
      } catch (error) {
        const message = handlerErrorV2(error)
        setError(message)
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [curriculumId])

  if (isLoading) return <Loading />

  return (
    <SectionCollapse title={`Units of learning (#${items?.length})`}>
      {items.length > 0 ? (
        <Grid container alignItems='center' spacing={1}>
          {items.map((item, index) => (
            <Grid item xs={12} lg={12 / 5} md={12 / 4} sm={12 / 3} key={`${item._id}-${index}`}>
              <CardUnitOfLearning key={`${item._id}-${index}`} item={item} onClick={undefined} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography className='text-muted-foreground opacity-50'>
          {"You don't have any units of learning yet"}
        </Typography>
      )}
    </SectionCollapse>
  )
}

export default FormUnitOfLearning
